export var EdgeInclusion;
(function (EdgeInclusion) {
    EdgeInclusion[EdgeInclusion["Left"] = 0] = "Left";
    EdgeInclusion[EdgeInclusion["Right"] = 1] = "Right";
})(EdgeInclusion || (EdgeInclusion = {}));
